import { FormControl, InputLabel, Select, MenuItem } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import useSWR from "swr";
import { ITable } from "../../Models/Entities";
import { BASE_URL, fetcher } from "../../Models/Fetcher";
import Loading from "../Utilities/Loading";
import SelectCustomer from "./SelectCustomer";

import "./styles.css";
import Table from "./Table";

export default () => {
  const [selectedCustomer, setSelectedCustomer] = useState(0);
  const [customerName, setCustomerName] = useState<string>("");
  const [loading, setLoading] = useState(true);
  const [tables, setTables] = useState<any>();
  const [selectedTables, setSelectedTables] = useState<any>();

  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedId = e.target.value;
    setSelectedCustomer(+selectedId);
  };

  useEffect(() => {
    const url = BASE_URL + "codetables";
    fetcher(url).then((res) => {
      setTables(res.data);
      setSelectedTables(res.data);
      setLoading(false);
    });
  }, []);

  useEffect(() => {
    if (!loading) {
      if (selectedCustomer === 0) {
        setSelectedTables(tables);
      } else {
        const filtered = tables.filter((table: any) => {
          return table.customer.id === selectedCustomer;
        });
        setSelectedTables(filtered);
      }
    }
  }, [selectedCustomer]);

  if (loading) {
    return (
      <div className="tables-display">
        <Loading />
      </div>
    );
  }

  return (
    <div className="tables-display">
      <div className="tables-display-area">
        <div className="area__header">
          <div className="area__name">All Tables</div>
          <div className="area__filter">
            <SelectCustomer handleChange={handleChange} />
          </div>
        </div>

        <div className="tables-container">
          {selectedTables.map((table: any) => {
            return (
              <Table
                key={table.id}
                id={table.id}
                name={table.name}
                description={table.description}
                locked={table.locked}
                lastEdited={table.lastEdited}
                customer={table.customer.name}
                color={table.customer.color}
              />
            );
          })}
        </div>
      </div>
    </div>
  );
};
